import { FiDownload, FiMapPin } from "react-icons/fi";
import { profile } from "../../data/portfolio";
import styles from "./About.module.css";

export default function About() {
  return (
    <section id="about" className={`section ${styles.about}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">About</p>
        <h2 className="sectionTitle">Engineer who ships products end to end</h2>
      </div>

      <div className={styles.grid}>
        <p className={styles.summary}>{profile.summary}</p>
        <div className={styles.aside}>
          <div className={styles.stat}>
            <strong>{profile.experience}</strong>
            <span>Professional experience</span>
          </div>
          <div className={styles.stat}>
            <strong>Full stack</strong>
            <span>Web · Mobile · AI</span>
          </div>
          <div className={styles.row}>
            <FiMapPin />
            <span>{profile.location}</span>
          </div>
          <a className={styles.resume} href={profile.links.resume} download="Barsa_Rani_Ojha_Resume">
            Download resume <FiDownload />
          </a>
        </div>
      </div>
    </section>
  );
}
